import { useState } from "react";
import { Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ className, testid, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input {...props} data-testid={testid} type={show ? "text" : "password"} className={className + " pr-11"} />
      <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow(!show)} aria-label={show ? "Nascondi password" : "Mostra password"}
        className="absolute right-1 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded text-slate-500 hover:text-brand-navy">
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}

const Box = ({ checked, onChange, testid, children }) => (
  <label className="flex items-start gap-3 text-xs text-slate-700 leading-relaxed cursor-pointer">
    <input type="checkbox" data-testid={testid} checked={!!checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 w-4 h-4 accent-[#0A2E5C] shrink-0" />
    <span>{children}</span>
  </label>
);

export function ConsentBoxes({ f, setF, withPrivacy = true }) {
  return (
    <div className="space-y-2.5 rounded-md border border-slate-200 bg-white p-3" data-testid="consent-boxes">
      {withPrivacy && (
        <Box testid="consent-privacy-checkbox" checked={f.privacy_accepted} onChange={(v) => setF({ ...f, privacy_accepted: v })}>
          <b>Obbligatorio.</b> Dichiaro di aver letto l'<Link to="/privacy" target="_blank" className="underline text-brand-navy">informativa privacy</Link> e i <Link to="/termini" target="_blank" className="underline text-brand-navy">termini e condizioni</Link>.
        </Box>
      )}
      <Box testid="consent-marketing-checkbox" checked={f.marketing_consent} onChange={(v) => setF({ ...f, marketing_consent: v })}>
        <b>Facoltativo.</b> Acconsento a ricevere email promozionali, offerte e novità da Halfa Stamps (marketing).
      </Box>
      <Box testid="consent-profiling-checkbox" checked={f.profiling_consent} onChange={(v) => setF({ ...f, profiling_consent: v })}>
        <b>Facoltativo.</b> Acconsento all'analisi dei miei acquisti per ricevere offerte personalizzate (profilazione).
      </Box>
      <p className="text-[11px] text-slate-500">Puoi cambiare i consensi facoltativi quando vuoi da "Il mio account → I miei dati".</p>
    </div>
  );
}
